import axios from "axios";
import {
  ADMIN_PRODUCTS_FAIL,
  ADMIN_PRODUCTS_REQUEST,
  ADMIN_PRODUCTS_SUCCESS,
  ALL_PRODUCTS_FAIL,
  ALL_PRODUCTS_REQUEST,
  ALL_PRODUCTS_SUCCESS,
  CLEAR_ERRORS,
  DELETE_PRODUCT_FAIL,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_REVIEW_FAIL,
  DELETE_REVIEW_REQUEST,
  DELETE_REVIEW_SUCCESS,
  GET_REVIEWS_FAIL,
  GET_REVIEWS_REQUEST,
  GET_REVIEWS_SUCCESS,
  NEW_PRODUCT_FAIL,
  NEW_PRODUCT_REQUEST,
  NEW_PRODUCT_SUCCESS,
  NEW_REVIEW_FAIL,
  NEW_REVIEW_REQUEST,
  NEW_REVIEW_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
} from "../constants/ProductConstants";

export const getProducts = (
  keyword = "",
  price = [1, 1000],
  category = "",
  rating = 0,
) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ALL_PRODUCTS_REQUEST,
      });
      let link = `https://ebuymait.herokuapp.com/api/v1/products?keyword=${keyword}&price[lte]=${price[1]}&price[gte]=${price[0]}&ratings[gte]=${rating}`;
      if (category) {
        link = `https://ebuymait.herokuapp.com/api/v1/products?keyword=${keyword}&price[lte]=${price[1]}&price[gte]=${price[0]}&category=${category}&ratings[gte]=${rating}`;
      }
      const { data } = await axios.get(link);
      console.log("-> ", data);
      dispatch({
        type: ALL_PRODUCTS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ALL_PRODUCTS_FAIL,
        payload: error.response,
      });
    }
  };
};

export const getProductDetails = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: PRODUCT_DETAILS_REQUEST,
      });
      const config = {
        withCredentials: "true",
      };
      const { data } = await axios.get(
        `https://ebuymait.herokuapp.com/api/v1/product/${id}`,
        config,
      );
      dispatch({
        type: PRODUCT_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PRODUCT_DETAILS_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};

export const newReview = (reviewData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: NEW_REVIEW_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: "true",
      };
      const { data } = await axios.post(
        `https://ebuymait.herokuapp.com/api/v1/review/`,
        reviewData,
        config,
      );
      dispatch({
        type: NEW_REVIEW_SUCCESS,
        payload: true,
      });
    } catch (error) {
      dispatch({
        type: NEW_REVIEW_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};

export const deleteProduct = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_PRODUCT_REQUEST,
      });
      const config = {
        withCredentials: "true",
      };
      const { data } = await axios.get(
        `https://ebuymait.herokuapp.com/api/v1/admin/delete/product/${id}`,
        config,
      );
      dispatch({
        type: DELETE_PRODUCT_SUCCESS,
        payload: data.success,
      });
    } catch (error) {
      console.log("frontend->error", error.response);
      dispatch({
        type: DELETE_PRODUCT_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};

export const newProduct = (productData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: NEW_PRODUCT_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: "true",
      };
      const { data } = await axios.post(
        `https://ebuymait.herokuapp.com/api/v1/admin/new/product`,
        productData,
        config,
      );
      dispatch({
        type: NEW_PRODUCT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log("frontend->error", error.response);
      dispatch({
        type: NEW_PRODUCT_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};
export const updateProduct = (id, productData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PRODUCT_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: "true",
      };
      const { data } = await axios.post(
        `https://ebuymait.herokuapp.com/api/v1/admin/update/product/${id}`,
        productData,
        config,
      );
      dispatch({
        type: UPDATE_PRODUCT_SUCCESS,
        payload: data.success,
      });
    } catch (error) {
      console.log("frontend->error", error.response);
      dispatch({
        type: UPDATE_PRODUCT_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};
export const getAdminProducts = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ADMIN_PRODUCTS_REQUEST,
      });
      const config = {
        withCredentials: "true",
      };
      const { data } = await axios.get(
        `https://ebuymait.herokuapp.com/api/v1/admin/products`,
        config,
      );
      dispatch({
        type: ADMIN_PRODUCTS_SUCCESS,
        payload: data.products,
      });
    } catch (error) {
      dispatch({
        type: ADMIN_PRODUCTS_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};

export const getProductReviews = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_REVIEWS_REQUEST,
      });
      const config = {
        withCredentials: "true",
      };
      const { data } = await axios.get(
        `https://ebuymait.herokuapp.com/api/v1/reviews?id=${id}`,
        config,
      );
      dispatch({
        type: GET_REVIEWS_SUCCESS,
        payload: data.reviews,
      });
    } catch (error) {
      dispatch({
        type: GET_REVIEWS_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};

export const deleteProductReviews = (id, productId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_REVIEW_REQUEST,
      });
      const config = {
        withCredentials: "true",
      };
      const { data } = await axios.get(
        `https://ebuymait.herokuapp.com/api/v1/reviews/delete/?id=${id}&productId=${productId}`,
        config,
      );
      dispatch({
        type: DELETE_REVIEW_SUCCESS,
        payload: data.success,
      });
    } catch (error) {
      dispatch({
        type: DELETE_REVIEW_FAIL,
        payload: error.response.data.message,
      });
    }
  };
};
export const clearErrors = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ERRORS,
    });
  };
};
